if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    $('.gallery-slider').slick({
        accessibility: false,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false 
                }
            }
        ]
    });
    $('.tr-gallery-left').slick({
        infinite: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: true,
        asNavFor: '.tr-gallery-right',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false 
                }
            }
        ]
    });

    $('.tr-gallery-right').slick({
        infinite: false,
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 7000,
        speed: 700,
        fade: false,
        // slidesToShow: 2,
        // slidesToScroll: 2,
        variableWidth: true,
        asNavFor: '.tr-gallery-left',
    });

    //email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
        
        let buttonSignup = document.querySelector('.signup-btn');
        console.log(buttonSignup);
        document.querySelector('#email-signup .fields-wrap .gdpr-wrap').appendChild(buttonSignup);
	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.form-module-wrapper')){
        document.querySelectorAll('.form-module-wrapper .form-module').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.global-sitemap')){
        document.querySelector('.global-sitemap').classList.add('animate-fade','top');
    }




    // WRAP MODULE TABLES
	document.querySelectorAll('.tableModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// MOBILE TABLE TO DROPDOWNS
	const tablesResp = document.querySelectorAll('.tableModule table');
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}

    // Funtion Added class active for primary nav
    document.querySelectorAll('.primary-nav li a').forEach((item) => {
        item.addEventListener('click', () => {
            item.closest('li').classList.toggle('active');
        })
    })
    // End funtion primary nav 


    // WRAP MODULE TABLES WITH FILTER
    document.querySelectorAll('.tableFilterModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableFilterModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// MOBILE  TABLE WITH FILTER TO DROPDOWNS
	const tablesMobile = document.querySelectorAll('.tableFilterModule table');
	if (tablesMobile.length) {
		tablesMobile.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}

    //End function table filter mobile

    /** Filter Capacity Chart Functionality **/

   /** Filter Capacity Chart Functionality **/

const tableFilter = document.querySelectorAll('.table-link');
const tableContent = document.querySelectorAll('.table-with-filter__copy');

function filterTables(filterValue) {
    tableContent.forEach((table) => {
        const tableFilterValue = table.getAttribute('data-filter');

        if (tableFilterValue === filterValue) {
            table.classList.remove('hidden');
        } else {
            table.classList.add('hidden');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (tableFilter.length > 0) {

        const firstFilter = tableFilter[0];
        filterTables(firstFilter.getAttribute('data-filter'));
    }
});

tableFilter.forEach((item) => {
    item.addEventListener('click', (event) => {
        event.preventDefault(); 
        
        const filterValue = item.getAttribute('data-filter');
        filterTables(filterValue);
    });
});


//*** END Filter Capacity Chart Functionality ***/


//***  filter capacity chartfor mobile ***/

    const mobileFilter = document.getElementById('mobileFilter'); 
    const tableContentMobile = document.querySelectorAll('.table-with-filter__copy'); 

    document.addEventListener('DOMContentLoaded', () => {
        if (mobileFilter) {
            const firstFilterValue = mobileFilter.value; 
            filterTables(firstFilterValue); valor
        }
    });
    function filterTables(filterValue) {
        tableContentMobile.forEach((table) => {
            const tableFilterValue = table.getAttribute('data-filter');
            console.log(filterValue);

            if ( tableFilterValue === filterValue) {
                table.classList.remove('hidden');
            } else {
                table.classList.add('hidden');
            }
        });
    }

    mobileFilter.addEventListener('change', (event) => {

        const filterValue = event.target.value; 
        console.log(filterValue);
        filterTables(filterValue); 
    });

//*** END filter capacity chartfor mobile ***/


})();